import { render, staticRenderFns } from "./closePg.vue?vue&type=template&id=04975ae6&scoped=true"
import script from "./closePg.vue?vue&type=script&lang=js"
export * from "./closePg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04975ae6",
  null
  
)

export default component.exports